<template>
    <NetworkOverlay />
    <RouterView />
    <UpdateAppModal />
</template>

<script>
import { SafeArea } from 'capacitor-plugin-safe-area'
import { PushNotifications } from '@capacitor/push-notifications'
import { useActiveRouteStore, useModalStore, useAuthStore } from '@/stores/index.js'
import NetworkOverlay from '@/components/NetworkOverlay.vue'
import UpdateAppModal from '@/components/modals/UpdateAppModal.vue'
import axios from 'axios'

export default {
    name: 'App',
    components: {
        NetworkOverlay,
        UpdateAppModal
    },
    setup() {
        const activeRouteStore = useActiveRouteStore()
        const modalStore = useModalStore()
        const authStore = useAuthStore()

        return { activeRouteStore, modalStore, authStore }
    },
    data() {
        return {
            updateMethods: {
                route: this.updateRoute,
                route_point: this.updatePoint,
                route_point_task: this.updateTask
            }
        }
    },
    mounted() {
        this.updateSafeAreaInsets()
        this.listenToSafeAreaChanges()
        this.addNotificationListeners()
        this.checkAppVersion()
    },
    beforeDestroy() {
        SafeArea.removeAllListeners()
    },
    methods: {
        addNotificationListeners() {
            PushNotifications.addListener('pushNotificationReceived', (notification) => {
                const events = JSON.parse(notification.data.event)

                events.map((item) => {
                    this.updateMethods[item.entity_type](item)
                })
            })

            PushNotifications.addListener('pushNotificationActionPerformed', () => {
                this.$router.push({ name: 'notificationsPage' })
            })
        },

        updateRoute() {
            this.activeRouteStore.loadActiveRouteData()
        },

        updatePoint(data) {
            this.activeRouteStore.loadPointData(data.entity_id)
        },

        updateTask() {},

        async updateSafeAreaInsets() {
            try {
                const { insets } = await SafeArea.getSafeAreaInsets()

                this.applySafeAreaPadding(insets)
            } catch (error) {
                console.error('Error getting safe area insets:', error)
            }
        },

        listenToSafeAreaChanges() {
            SafeArea.addListener('safeAreaChanged', ({ insets }) => {
                this.applySafeAreaPadding(insets)
            })
        },

        applySafeAreaPadding(insets) {
            const padding = `${insets.top}px ${insets.right}px ${insets.bottom}px ${insets.left}px`

            document.documentElement.style.setProperty('padding', padding)
        },

        async checkAppVersion() {
            const versionUrl = import.meta.env.VITE_DRIVER_APP_VERSION_URL
            const currentVersion = import.meta.env.VITE_APP_VERSION

            if (!versionUrl) return

            try {
                const response = await axios.get(versionUrl)
                const latestVersion = response.data?.version

                if (latestVersion && latestVersion !== currentVersion) {
                    this.authStore.clearUserSession()
                    this.modalStore.updateAppModal.downloadUrl = versionUrl.replace(
                        'version.php',
                        'apk.php'
                    )
                    this.modalStore.updateAppModal.show = true
                }
            } catch (error) {
                console.error('Error checking app version:', error)
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
